// extracted by mini-css-extract-plugin
module.exports = {"positive":"AmountTheme__positive--33Cgn","negative":"AmountTheme__negative--PlOht"};